<div class="main-container">
  <div>
    <div class="ic1-header">
      <div class="ic1-header-logo">
        <div class="ic1-header-brand-ipp"></div>
      </div>
    </div>
  </div>
  <div class="content">
    <div class="col-5 content-left-background ">
      <div class="content-left">
        <div *ngIf="leftTextShow" class="ic1-warning-message">
          <div class="ic1-warning-message-content">
              <div class="ic1-toast-text-container">
                  <p class="ic1-warning-message-content-text" [innerHTML]="leftText"></p>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-7">
      <div class="content-right">
        <div>
          <div class="ic1-right-logo"></div>
          <div class="ic1-right-text-heading-1">{{ 'LOGIN.HEADING' | translate }}</div>
          <div class="ic1-right-text-subtitle-1">{{ 'LOGIN.SUBTITLE' | translate }}</div>
          <button class="ic1-right-login-button" id="prelogin-button-login" (click)="clickLogin()">{{ 'LOGIN.BUTTON' | translate }}</button>
          <ng-container *ngIf="errorText">
            <div class="ic1-error-message">
              <div class="ic1-error-message-content">
                  <div class="ic1-toast-text-container">
                      <h5>Authentication error</h5>
                      <h6>{{errorText}}</h6>
                  </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="ic1-footer">
      <div class="ic1-footer-content">
        <div class="ic1-footer-left">{{footerTextLeft}}</div>
        <div class="ic1-footer-right">
          <div class="ic1-footer-copy">{{footerTextRight}}</div>
          <ul class="ic1-footer-list">
            <li class="ic1-footer-list-item"><div class="ic1-footer-button">{{footerTextVersion}}</div></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>